import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import {FormGroup} from "@angular/forms";
import { Subscription } from 'rxjs';
import {FormEntityExtensionService} from "./form-entity-extension.service";

@Component({
  template: ''
})
export class FormEntityExtension implements OnChanges {

  form: FormGroup;
  data: any;
  initFormValue: any;
  leaveFormValue: any;
  routerChange$: Subscription;

  @Input('data') set data$(value) {
    if (value) this.data = value;
    this.patchValue();
  }

  @Output() submited: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  @Output() formGroup: EventEmitter<FormGroup> = new EventEmitter();

  constructor(protected formEntityExtensionService: FormEntityExtensionService) {
  }

  patchValue() {
    if (this.data && this.form) {
      this.setForm();
      this.form.patchValue(this.data);
      this.formEntityExtensionService.formService.setDefaultValues(this.form);
      this.initFormValue = this.form.value;
    }
  }

  setForm() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('data' in changes) {
      setTimeout(() => {
        if (changes.data.currentValue) {
          this.form.patchValue(changes.data.currentValue);
          this.formEntityExtensionService.formService.setDefaultValues(this.form);
        }
      });
    }
  }

  initForm(formGroup: FormGroup) {
    this.form = formGroup;
    this.patchValue();
    this.formGroup.emit(this.form);

    this.formEntityExtensionService.formService.setDefaultValues(this.form);
    this.formEntityExtensionService.formService.setActiveForms([this.form]);
  }

  onSubmit() {
    if (this.formEntityExtensionService.validateService.validate(this.form)) {
      this.formEntityExtensionService.formService.setForceSkipCheck();
      this.submited.emit(this.form);
    } else {
      this.formEntityExtensionService.toastrService.warning(this.formEntityExtensionService.messageService.incorrectField, 'Warning');
    }
  }

}
